export default "__VITE_ASSET__BFzDmbdI__"